module.exports = __webpack_public_path__ + "static/media/pay-per-click.20fb9026.svg";